import React from "react";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

export default function Menu() {
  const logOut = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("role");
    sessionStorage.removeItem("userName");
    window.location.reload();
  };
  const roleString = sessionStorage.getItem('role');
  if(roleString==='Quản trị'){
  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      bg="dark"
      variant="dark"
      className="p-2"
    >
      <Container>
        <Navbar.Brand href="#">VIJATECH</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <Nav.Item style={{marginLeft: "20px"}}>
              {" "}
              <Link className="text-decoration-none text-white" to="/">
                Lịch chung
              </Link>
            </Nav.Item>
            <Nav.Item style={{marginLeft: "20px"}}>
              {" "}
              <Link className="text-decoration-none text-white" to="/Calendar">
                Lịch cá nhân
              </Link>
            </Nav.Item>
            <Nav.Item style={{marginLeft: "20px"}}>
              {" "}
              <Link className="text-decoration-none text-white" to="/ListUser">
              Danh sách người dùng
              </Link>
            </Nav.Item>
          </Nav>
          <Nav className="gap-2">
            <Nav.Link>
              <label onClickCapture={logOut}>Đăng xuất</label>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );}
  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      bg="dark"
      variant="dark"
      className="p-2"
    >
      <Container>
        <Navbar.Brand href="#">VIJATECH</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <Nav.Item style={{marginLeft: "20px"}}>
              {" "}
              <Link className="text-decoration-none text-white" to="/">
                Lịch chung
              </Link>
            </Nav.Item>
            <Nav.Item style={{marginLeft: "20px"}}>
              {" "}
              <Link className="text-decoration-none text-white" to="/Calendar">
                Lịch cá nhân
              </Link>
            </Nav.Item>
            <Nav.Item style={{marginLeft: "20px"}}>
              {" "}
              <Link className="text-decoration-none text-white" to="/ChangeInf">
                Thay đổi thông tin
              </Link>
            </Nav.Item>
          </Nav>
          <Nav className="gap-2">
            <Nav.Link>
              <label onClickCapture={logOut}>Đăng xuất</label>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );

}
